import * as React from 'react';
const SvgPrintProduction = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M34.903 81.355V29.097H19.42C9.8 29.097 2 21.297 2 11.677h32.903V5.871A3.87 3.87 0 0 1 38.774 2h32.903L122 19.42v9.677H54.258"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.806 81.355H19.42C9.8 81.355 2 89.155 2 98.775h27.097v5.806a3.87 3.87 0 0 0 3.87 3.871h42.581L122 91.032v-9.677H67.806ZM34.903 108.452V122M62 108.452V122M62 29.097v52.258M87.17 49.424l11.604 6.77 11.613-6.775"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m75.548 42.645 23.226-13.548L122 42.645v25.161L98.774 81.356M98.774 67.806V56.194"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.548 42.645v25.161l23.226 13.549"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPrintProduction;
